import { RewardNotification } from '@repo/ui'
import type { Notification } from '../../types/domain'
import { rewardTagByType } from '../../factories/rewardTags.factories'
import { NotificationRewardTag } from '../NotificationRewardTag/NotificationRewardTag'

type NotificationProps = Readonly<{
  notification: Notification
  onClose: () => void
}>

export function NotificationMessage({ notification, onClose }: NotificationProps) {
  const { item } = notification
  // @ts-expect-error - TypeScript can't narrow the discriminated union properly in this context
  const rewardTagProps = rewardTagByType[item.type](item, onClose)

  return (
    <RewardNotification
      accentColor={item.accentColor || 'blue'}
      icon={item.icon}
      rewardTag={<NotificationRewardTag {...rewardTagProps} onClose={onClose} />}
      subtitle={item.subtitle}
      title={item.title}
    />
  )
}
